import { ref } from 'vue'

export const useMedicalValues = () => {
  const selectInoculationHistories = ref([
    '0回',
    '1回',
    '2回',
    '3回',
    '4回',
    '5回',
    '不明',
  ])

  const selectVaccines = ref([
    'ファイザー社１価ワクチン（起源株）',
    'ファイザー社２価ワクチン（BA.1）',
    'ファイザー社２価ワクチン（BA.4-5）',
    'モデルナ社１価ワクチン（起源株）',
    'モデルナ社２価ワクチン（BA.1）',
    'モデルナ社２価ワクチン（BA.4-5）',
    '武田（ノババックス）',
    'アストラゼネカ',
    '不明',
  ])

  const selectSearchMethods = ref([
    '華膣ぬぐい液(鼻の奥)',
    '咽頭ぬぐい液(喉の奥)',
    '唾液'
  ])

  const selectFever = ref([
    '37.5度未満',
    '37.5度以上'
  ])

  const selectDiagnosticResult = ref([
    '新型コロナウイルス陽性',
    'インフルエンザ'
  ])

  return {
    selectInoculationHistories,
    selectVaccines,
    selectSearchMethods,
    selectFever,
    selectDiagnosticResult
  }

}
